<template>
  <v-container>
    <v-overlay v-model="overlay" color="white" opacity="1" persistent>
      <v-container style="text-align: center">
        <v-progress-circular :size="50" color="#234a98" indeterminate></v-progress-circular>
        <p class="pt-2" style="font-size: 14px; color: #234a98">
          {{ $t('common.loading') }}
        </p>
      </v-container>
    </v-overlay>
    <v-dialog v-model="scelta" max-width="1200" width="95%" persistent>
      <v-card class="mb-4" width="100%" flat>
        <v-card-title>
          {{ $t('airQuality.selectSensor') }}
        </v-card-title>
        <v-card-text>
          <v-layout class="mt-4" id="makeMeBlue">
            <v-flex class="px-2">
              <v-select class="v-select" v-model="client" :items="clients" :label="$t('manageSensors.client')" outlined :no-data-text="$t('common.noDataAvailable')">
              </v-select>
            </v-flex>
            <v-flex class="px-2">
              <v-select v-model="building" :items="buildings" :label="$t('manageSensors.building')" outlined
                :disabled="buildingActive" :no-data-text="$t('common.noDataAvailable')">
              </v-select>
            </v-flex>
            <v-flex class="px-2">
              <v-select v-model="floor" :items="floors" :label="$t('manageSensors.floor')" outlined :disabled="floorActive" :no-data-text="$t('common.noDataAvailable')">
              </v-select>
            </v-flex>
            <v-flex class="px-2">
              <v-select v-model="area" :items="areas" :label="$t('manageSensors.area')" outlined :disabled="areaActive" :no-data-text="$t('common.noDataAvailable')">
              </v-select>
            </v-flex>
            <v-flex class="px-2">
              <v-select v-model="sensorsValue" :items="sensor_items" :label="$t('manageSensors.sensor')" outlined :key="s"
                :disabled="sensorActive" :no-data-text="$t('common.noDataAvailable')">
              </v-select>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn text color="#213A8F" @click="goBack">{{ $t('common.back').toUpperCase() }}</v-btn>
          <v-btn text color="#213A8F" :disabled="okActive" @click="LoadData()">{{ $t('common.ok') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card width="100%" flat v-show="!scelta">
      <v-card-text>
        <v-layout class="mt-4" id="changeMyColor">
          <v-flex xs6 sm3 md3>
            <v-select class="v-select" v-model="client" :items="clients" label="Client" outlined :no-data-text="$t('common.noDataAvailable')">
            </v-select>
          </v-flex>
          <v-flex xs6 sm3 md3>
            <v-select class="ml-2" v-model="building" :items="buildings" :label="$t('manageSensors.building')" outlined :key="b" :no-data-text="$t('common.noDataAvailable')">
            </v-select>
          </v-flex>
          <v-flex xs6 sm3 md3>
            <v-select class="ml-2" v-model="floor" :items="floors" :label="$t('manageSensors.floor')" outlined :key="f"
              :disabled="floorActive" :no-data-text="$t('common.noDataAvailable')">
            </v-select>
          </v-flex>
          <v-flex xs6 sm3 md3>
            <v-select class="ml-2" v-model="area" :items="areas" :label="$t('manageSensors.area')" outlined :disabled="areaActive" :no-data-text="$t('common.noDataAvailable')">
            </v-select>
          </v-flex>
          <v-flex xs6 sm3 md3>
            <v-select class="ml-2" v-model="sensorsValue" :items="sensor_items" :label="$t('manageSensors.sensor')" outlined :key="s"
              :disabled="sensorActive" :no-data-text="$t('common.noDataAvailable')">
            </v-select>
          </v-flex>
          <v-flex xs6 sm3 md3 class="ml-2">
            <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :return-value.sync="date"
              transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field outlined v-model="date" :label="$t('smartDispenser.selectDateRange')" prepend-inner-icon="mdi-calendar"
                  readonly v-bind="attrs" v-on="on"></v-text-field>
              </template>
              <v-date-picker v-model="date" no-title scrollable locale="en" range :max="maxDate" :min="minDate"
                @click="SetMinDate">
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu = false">
                  {{ $t('common.cancel') }}
                </v-btn>
                <v-btn text color="primary" @click="$refs.menu.save(date); GetDataByDate()">
                  {{ $t('common.ok') }}
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex>
        </v-layout>
        <hr class="mt-4" style="border-top: solid 1px; color: #BFCCE4" />
        <v-layout v-show="visualizza_dati && !scelta">
          <v-flex xs2 sm6 md3 class="mt-6 mb-4 mr-0 ml-0 justify-left">
            <h2 style="font-weight: bold;">{{ $t('smartDispenser.quickFilters') }} </h2>
          </v-flex>
          <v-flex xs2 sm6 md3>
            <v-btn text @click="ChangeDate('4h', request)" class="mt-4 mb-4 mr-0 ml-0">
              <h2 :style="'color: ' + colore4h">| {{ $t('smartDispenser.hours') }} |</h2>
            </v-btn>
          </v-flex>
          <v-flex xs2 sm6 md3>
            <v-btn text @click="ChangeDate('1', request)" class="mt-4 mb-4 mr-0 ml-0">
              <h2 :style="'color: ' + colore1d">| {{ $t('smartDispenser.day') }} |</h2>
            </v-btn>
          </v-flex>
          <v-flex xs2 sm6 md3>
            <v-btn text @click="ChangeDate('3', request)" class="mt-4 mb-4 mr-0 ml-0">
              <h2 :style="'color: ' + colore3d">| {{ $t('smartDispenser.threeDays') }} |</h2>
            </v-btn>
          </v-flex>
          <v-flex xs2 sm6 md3>
            <v-btn text @click="ChangeDate('7', request)" class="mt-4 mb-4 mr-0 ml-0">
              <h2 :style="'color: ' + colore1w">| {{ $t('smartDispenser.week') }} |</h2>
            </v-btn>
          </v-flex>
          <v-flex xs2 sm6 md3>
            <v-btn text @click="ChangeDate('14', request)" class="mt-4 mb-4 mr-0 ml-0">
              <h2 :style="'color: ' + colore2w">| {{ $t('smartDispenser.twoWeeks') }} |</h2>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <hr style="border-top: solid 1px; color: #BFCCE4" />
    <h2 class="mt-4">{{ sensor_name }}</h2>
    <hr class="mt-4" style="border-top: solid 1px; color: #BFCCE4" />
    <v-card class="mt-4" height="100%" flat v-show="visualizza_dati && !scelta">
      <v-card-text>

        <!-- <v-layout class="mt-4 mr-4 mb-4 ml-4">
                        <v-flex xs12 sm12 md6> -->
        <!-- <v-card height="100%" class="mt-4 mr-4 mb-4 ml-4" flat>
                                <v-card-text>
                                    <h2 class="align-center justify-center">DATA MANAGER</h2>
                                </v-card-text>
                                <v-layout>
                                    <v-flex sm6 md6 >
                                      <img class="mt-8 mr-16 align-left" :src="sensor_img" width="70%"/>
                                    </v-flex>
                                    <v-flex sm6 md6>
                                        <v-card-text class="text-left">
                                            <h3>Sensor name:</h3> {{ sensor_name }}
                                            <h3 class="mt-8">Building:</h3> {{ building_name }}
                                            <h3 class="mt-12">Floor: </h3> {{ floor_name }}
                                            <h3 class="mt-8">Level status: </h3> <v-icon :color="colore_stato">mdi-circle</v-icon> -->
        <!-- <h3>Last time empty: </h3> {{ last_refill }} -->
        <!-- </v-card-text>
                                    </v-flex>
                                </v-layout>
                            </v-card> -->
        <!-- </v-flex>
                        <div style="border-left: 1px solid #BFCCE4; height: 350px;" class="mt-4"></div>
                        <v-flex xs12 sm12 md6>
                            <v-card height="100%" class="mt-4 mr-4 mb-4 ml-4" flat>
                                <v-card-text>
                                    <h2 style="color: #213A8F !important">AIR QUALITY</h2>
                                </v-card-text>
                                <v-card-text class="justify-center">
                                <v-layout>
                                    <v-flex xs12 sm12 md12 class="justify-center mt-8"> -->
        <!-- <apexchartComponent type="radialBar" height="350" :options="PunctualchartOptions" :series="series_punctual" :key="radialKey"></apexchartComponent> -->
        <!-- <apexchartComponent type="bar" height="50" :options="PunctualchartOptions" :series="series_punctual" :key="keyPunctual"></apexchartComponent>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex xs12 sm12 md12 class="text-center mt-4">
                                        <div class="mt-4" style="display: inline-block;"><h3 style="display: inline-block;">Date: </h3> <h4 style="display: inline-block; font-weight: normal;">{{ DataSensore }}</h4></div>
                                        <div class="mt-8"><h3 style="display: inline-block;"></h3> <h4 style="display: inline-block; font-weight: normal;">{{ GiornoSettimana }}</h4></div>
                                        <div class="mt-8"><h3 style="display: inline-block;">Time: </h3> <h4 style="display: inline-block; font-weight: normal;"> {{ OraSensore }}</h4></div>
                                    </v-flex>
                                </v-layout>
                                
                                </v-card-text>
                            </v-card> -->
        <!-- </v-flex>
                </v-layout > -->
        <!-- <hr class="mt-4" style="border-top: solid 1px; color: #BFCCE4"/> -->
        <v-layout>

          <v-flex xs4 sm4 md4>
            <v-btn text @click="ChangeDate('1', 'CO2')" class="mt-4 mb-4 mr-4 ml-4">
              <h2 :style="'color: ' + coloreCO2">CO2</h2>
            </v-btn>
          </v-flex>
          <v-flex xs4 sm4 md4>
            <v-btn text @click="ChangeDate('1', 'HUMIDITY')" class="mt-4 mb-4 mr-4 ml-4">
              <h2 :style="'color: ' + coloreHumidity">HUMIDITY</h2>
            </v-btn>
          </v-flex>
          <v-flex xs4 sm4 md4>
            <v-btn text @click="ChangeDate('1', 'TEMPERATURE')" class="mt-4 mb-4 mr-4 ml-4">
              <h2 :style="'color: ' + coloreTemperature">TEMPERATURE</h2>
            </v-btn>
          </v-flex>
          <v-flex xs4 sm4 md4>
            <v-btn text @click="ChangeDate('1', 'PRESSURE')" class="mt-4 mb-4 mr-4 ml-4">
              <h2 :style="'color: ' + colorePressure">PRESSURE</h2>
            </v-btn>
          </v-flex>
        </v-layout>
        <hr class="mt-4" style="border-top: solid 1px; color: #BFCCE4" />
        <h2 style="margin-top: 15px;">{{ chart_title }}</h2>
        <v-card-text>
          <apexchartComponent type="line" height="350" :options="chartOptions_bin" :series="series_bin" :key="chartk" />
        </v-card-text>
      </v-card-text>
    </v-card>
    <v-card>

    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
import { addPeriodSubtitleToChartOptions } from "@/utils/chartPeriodFormatter";
import { applyTimezoneToApexCharts } from "@/utils/chartDateFormatter";
// import AnimatedNumber from "animated-number-vue";
export default {

  // components: {
  //     AnimatedNumber
  // },
  name: 'SmartBinView',
  data() {
    return {
      isLoadingFromRoute: false, // Flag per evitare interferenze dei watcher durante il caricamento dalla route
      currentStartDate: null, // Data inizio periodo corrente per sottotitoli grafici
      currentEndDate: null,   // Data fine periodo corrente per sottotitoli grafici
      scelta: true,
      client: "",
      clients: [],
      buildingActive: true,
      areaActive: true,
      building: "",
      buildings: [],
      floor: "",
      floors: [],
      area: "",
      areas: [],
      sensorActive: true,
      floorActive: true,
      sensor_id: "",
      sensor_items: [],
      sensorsValue: "",
      okActive: true,
      b: 0,
      f: 0,
      s: 0,
      colore4h: "#DAE0EC",
      colore1d: "#DAE0EC",
      colore3d: "#DAE0EC",
      colore1w: "#DAE0EC",
      colore2w: "#DAE0EC",
      coloreCO2: "#213A8F",
      coloreHumidity: "#DAE0EC",
      coloreTemperature: "#DAE0EC",
      colorePressure: "#DAE0EC",
      request: "CO2",
      sensor_unique: 'FCA84A030000066C',
      maxDate: "",
      minDate: "",
      chartk: 0,
      chart_title: '',
      visualizza_dati: true,
      overlay: false,
      show: true,
      sensor_name: "Air Quality Office",
      to_display: [{ text: "Hourly", value: 0 }, { text: "Daily", value: 1 }, { text: "Weekly", value: 2 }],
      displayed_range: "",
      sensor_datas: [],
      menu: false,
      date: [],
      floor_items: [],
      floorValue: "",
      buildingValue: [],
      lista_bin: [{ text: "test Bin Sensor" }],
      valueBin: [],
      dialogBin: false,
      series_bin: [],


      chartOptions_bin: {
        chart: {
          toolbar: {
            show: false,
          },
          type: 'line',
          height: 650,
        },
        responsive: [{
          breakpoint: 480,
          options: {
            legend: {
              position: 'bottom',
              offsetX: -10,
              offsetY: 0
            }
          }
        }],
        stroke: {
          curve: 'smooth'
        },
        yaxis: {
          title: {
            text: '',
            rotate: 360,
            offsetY: -160,


          },
          // min: 0,
          // max: 100,

          labels: {
            offset: 10,
            formatter: function (value) {
              return Number(value).toFixed(2);
            },
          }
        },
        xaxis: {
          categories: [
          ],
          labels: {
            style: {
              colors: [],
              fontSize: '10px',
              fontFamily: 'Helvetica, Arial, sans-serif',
              fontWeight: 400,
              cssClass: 'apexcharts-xaxis-label',
            },
          },
        },
        fill: {
          opacity: 1
        },
        legend: {
          position: 'right',
          offsetX: 0,
          offsetY: 50
        },
      },
    }
  },
  created() {
    this.overlay = true;
    this.DownloadCompanyDatas();
    // this.colore1d = "#213A8F"
  },
  mounted() {
    this.applyChartsTimezone();
    // this.loading = true;
    // this.displayed_range = 0;
    // this.date.push(new Date().toISOString().toString().substr(0, 10));
    // this.ChangeDate('1', "CO2")


  },
  methods: {
    applyChartsTimezone() {
      applyTimezoneToApexCharts(
        { chartOptions_bin: this.chartOptions_bin },
        this.$store.state.timezone || 'Europe/Rome'
      );
    },
    updateAllChartSubtitles() {
      // Aggiorna i sottotitoli di tutti i grafici con il periodo corrente
      if (!this.currentStartDate || !this.currentEndDate) {
        return;
      }
      
      const locale = this.$i18n.locale || 'en';
      
      // Aggiorna chartOptions con i sottotitoli del periodo usando $set per garantire la reattività
      this.$set(this, 'chartOptions_bin', addPeriodSubtitleToChartOptions(
        this.chartOptions_bin, 
        this.currentStartDate, 
        this.currentEndDate, 
        locale
      ));
      this.applyChartsTimezone();
    },
    
    async DownloadCompanyDatas() {
      try {
        // Se ci sono parametri nella route, nascondi il dialog di scelta immediatamente
        if (this.$route.params && this.$route.params.sensorId) {
          this.scelta = false;
          // Imposta la flag per evitare che i watcher interferiscano
          this.isLoadingFromRoute = true;
        }
        
        // Carica i clienti
        const clientsResponse = await axios.post(this.$store.state.URL_GET_AVAILABLE_CLIENT);
        this.clients = clientsResponse.data.map(el => ({ text: el.CompanyName, value: el.id }));
        
        // Se ci sono parametri nella route, carica i dati del sensore
        if (this.isLoadingFromRoute) {
          const { company, building, floor, area, sensorId } = this.$route.params;
          console.log('Parametri route ricevuti (Air Quality):', { company, building, floor, area, sensorId });
          
          // Abilita i campi e imposta il cliente
          this.buildingActive = false;
          this.floorActive = false;
          this.areaActive = false;
          this.sensorActive = false;
          this.client = parseInt(company);
          
          // Carica gli edifici
          const buildingsResponse = await axios.post(this.$store.state.URL_GET_AVAILABLE_BUILDINGS, {
            companyId: parseInt(company)
          });
          this.buildings = buildingsResponse.data.map(el => ({ text: el.BuildingName, value: el.id }));
          
          // Imposta l'edificio e carica i piani
          this.building = parseInt(building);
          const floorsResponse = await axios.post(this.$store.state.URL_GET_AVAILABLE_FLOORS, {
            buildingId: parseInt(building)
          });
          this.floors = floorsResponse.data.map(el => ({ text: el.FloorName, value: el.id }));
          
          // Imposta il piano e carica le aree
          this.floor = parseInt(floor);
          const areasResponse = await axios.post(this.$store.state.URL_GET_AVAILABLE_AREAS, {
            floorId: parseInt(floor)
          });
          this.areas = areasResponse.data.map(el => ({ text: el.AreaName, value: el.id }));
          
          // Imposta l'area e carica i sensori
          this.area = parseInt(area);
          const sensorsResponse = await axios.post(this.$store.state.URL_GET_SENSORS_COMPANY_BUILDING_FLOOR_AREA, {
            companyId: parseInt(company),
            buildingId: parseInt(building),
            floorId: parseInt(floor),
            areaId: parseInt(area),
            type: "Air"
          });
          
          this.sensor_items = sensorsResponse.data.map(el => ({ text: el.DisplayName, value: el }));
          
          console.log('Sensori disponibili (Air):', sensorsResponse.data.map(s => ({ id: s.id, name: s.DisplayName })));
          console.log('Cerco sensore con id:', sensorId, 'tipo:', typeof sensorId);
          
          // Trova e imposta il sensore corretto usando l'id
          const sensor = sensorsResponse.data.find(s => s.id === parseInt(sensorId));
          console.log('Sensore trovato:', sensor);
          
          if (sensor) {
            // Imposta sensorsValue con l'oggetto sensore diretto (come fa WashroomFrequencyView)
            this.sensorsValue = sensor;
            this.sensor_name = sensor.DisplayName;
            this.sensor_img = sensor.DispenserImage;
            this.sensor_unique = sensor.DispenserUnique;
            this.sensor_id = sensor.DispenserId;
            this.okActive = false;
            
            // Resetta la flag prima di caricare i dati (così i watcher funzionano normalmente)
            this.isLoadingFromRoute = false;
            // Carica i dati con il filtro di 1 giorno e CO2
            this.ChangeDate('1', 'CO2');
          } else {
            console.error('Sensore non trovato con id:', sensorId);
            this.isLoadingFromRoute = false;
            this.overlay = false;
          }
        } else {
          // Nessun parametro nella route, resetta la flag
          this.isLoadingFromRoute = false;
          this.overlay = false;
        }
      } catch (error) {
        console.error('Errore nel caricamento dei dati:', error);
        this.isLoadingFromRoute = false;
        this.overlay = false;
      }
    },
    ChangeDate(period, req) {
      this.visualizza_dati = true;
      this.scelta = false;
      this.overlay = true;
      console.log(period, req);
      
      // Aggiorna i colori delle metriche (CO2, HUMIDITY, TEMPERATURE, PRESSURE)
      this.coloreCO2 = req === 'CO2' ? "#213A8F" : "#DAE0EC";
      this.coloreHumidity = req === 'HUMIDITY' ? "#213A8F" : "#DAE0EC";
      this.coloreTemperature = req === 'TEMPERATURE' ? "#213A8F" : "#DAE0EC";
      this.colorePressure = req === 'PRESSURE' ? "#213A8F" : "#DAE0EC";
      
      switch (period) {
        case "4h":
          this.GetSensorData(this.subtractHours(4, new Date()).toISOString().toString().substr(0, 19), new Date().toISOString().toString().substr(0, 19), req);
          // this.chartOptions_stacked.plotOptions.bar.columnWidth = "15%"
          this.colore4h = "#213A8F"
          this.colore1d = "#DAE0EC"
          this.colore3d = "#DAE0EC"
          this.colore1w = "#DAE0EC"
          this.colore2w = "#DAE0EC"
          break;
        case "1":
          this.GetSensorData(this.subtractDays(0, new Date()).toISOString().toString().substr(0, 10), this.subtractDays(1, new Date()).toISOString().toString().substr(0, 10), req);
          // this.chartOptions_stacked.plotOptions.bar.columnWidth = "15%"
          this.colore4h = "#DAE0EC"
          this.colore1d = "#213A8F"
          this.colore3d = "#DAE0EC"
          this.colore1w = "#DAE0EC"
          this.colore2w = "#DAE0EC"
          break;
        case "3":
          this.GetSensorData(this.subtractDays(-2, new Date()).toISOString().toString().substr(0, 10), this.subtractDays(1, new Date()).toISOString().toString().substr(0, 10), req);
          // this.chartOptions_stacked.plotOptions.bar.columnWidth = "40%"
          this.colore3d = "#213A8F";
          this.colore4h = "#DAE0EC"
          this.colore1d = "#DAE0EC"
          this.colore1w = "#DAE0EC"
          this.colore2w = "#DAE0EC"
          break;
        case "7":
          this.GetSensorData(this.subtractDays(-6, new Date()).toISOString().toString().substr(0, 10), this.subtractDays(1, new Date()).toISOString().toString().substr(0, 10), req);
          // this.chartOptions_stacked.plotOptions.bar.columnWidth = "70%"
          this.colore1w = "#213A8F";
          this.colore3d = "#DAE0EC";
          this.colore4h = "#DAE0EC"
          this.colore1d = "#DAE0EC"
          this.colore2w = "#DAE0EC"
          break;
        case "14":
          this.GetSensorData(this.subtractDays(-13, new Date()).toISOString().toString().substr(0, 10), this.subtractDays(1, new Date()).toISOString().toString().substr(0, 10), req);
          // this.chartOptions_stacked.plotOptions.bar.columnWidth = "70%"
          this.colore2w = "#213A8F";
          this.colore1w = "#DAE0EC";
          this.colore3d = "#DAE0EC";
          this.colore4h = "#DAE0EC"
          this.colore1d = "#DAE0EC"
          break;
      }
    },
    subtractHours(numOfHours, date = new Date()) {
      date.setHours(date.getHours() - numOfHours + 1);
      return date;
    },
    subtractDays(numOfDays, date = new Date()) {
      date.setDate(date.getDate() + numOfDays);

      return date;
    },

    SetMinDate() {
      this.minDate = this.maxDate;
    },
    GetDataByDate() {
      this.overlay = true;
      const startDate = this.subtractDays(0, new Date(this.date[0])).toISOString().toString().substr(0, 10);
      const endDate = this.subtractDays(1, new Date(this.date[1])).toISOString().toString().substr(0, 10);
      
      // Salva le date per i sottotitoli dei grafici
      this.currentStartDate = startDate + " 00:00:00";
      this.currentEndDate = endDate + " 23:59:59";
      
      // Usa il request corrente per mantenere la metrica selezionata
      this.GetSensorData(startDate, endDate, this.request);
    },
    addDays(date, days) {
      date.setDate(date.getDate() + days);
      return date;
    },
    GetSensorData(start, nextDay, req = "CO2") {
      start = start.length == 10 ? start + " 00:00:00" : start.replace("T", " ");
      nextDay = nextDay.length == 10 ? nextDay + " 00:00:00" : nextDay.replace("T", " ");
      
      // Salva le date per i sottotitoli dei grafici
      this.currentStartDate = start;
      this.currentEndDate = nextDay;
      
      var data_ = [];
      
      // Reset del grafico prima di caricare nuovi dati
      this.chartOptions_bin.xaxis.categories = [];
      this.series_bin = [];
      
      // Imposta il titolo in base al tipo di richiesta (visibile anche senza dati)
      switch (req) {
        case 'CO2':
          this.request = 'CO2';
          this.chartOptions_bin.yaxis.title.text = '(ppm)';
          this.chart_title = req + " Level";
          break;
        case 'HUMIDITY':
          this.request = 'HUMIDITY';
          this.chartOptions_bin.yaxis.title.text = '(%RH)';
          this.chart_title = req.charAt(0).toUpperCase() + req.slice(1).toLowerCase() + " Level";
          break;
        case 'TEMPERATURE':
          this.request = 'TEMPERATURE';
          this.chartOptions_bin.yaxis.title.text = '(°C)';
          this.chart_title = req.charAt(0).toUpperCase() + req.slice(1).toLowerCase() + " Level";
          break;
        case 'PRESSURE':
          this.request = 'PRESSURE';
          this.chartOptions_bin.yaxis.title.text = '(mBar)';
          this.chart_title = req.charAt(0).toUpperCase() + req.slice(1).toLowerCase() + " Level";
          break;
      }
      
      // Forza l'aggiornamento del grafico (scheletro vuoto)
      this.chartk++;
      
      console.log(start, nextDay, req);
      
      axios.post(this.$store.state.URL_GET_DATA_FROM_DYNAMO,
        {
          "sensor_id": this.sensor_unique,
          "from": start,
          "to": nextDay
        }
      )
        .then(res => {
          // Verifica che la risposta contenga dati validi
          if (!res.data || !Array.isArray(res.data) || res.data.length === 0) {
            console.log("Nessun dato disponibile per il periodo selezionato");
            // Mostra comunque il grafico vuoto
            this.series_bin = [{ data: [], name: req }];
            this.chartk++;
            this.updateAllChartSubtitles();
            this.overlay = false;
            return;
          }
          
          switch (req) {
            case ('CO2'):
              for (var y = 0; y < res.data.length; y++) {
                try {
                  const el = res.data[y];
                  // Verifica che device_data e i campi necessari esistano
                  if (!el || !el.device_data) {
                    console.log("Elemento saltato - device_data mancante:", y);
                    continue;
                  }
                  if (el.device_data.received_at == null || el.device_data.co2_ppm == null) {
                    console.log("Elemento saltato - dati CO2 mancanti:", y);
                    continue;
                  }
                  this.chartOptions_bin.xaxis.categories.push(el.device_data.received_at);
                  data_.push(el.device_data.co2_ppm);
                } catch (e) {
                  console.log("Errore durante l'elaborazione dell'elemento CO2:", y, e);
                  continue;
                }
              }
              break;
            case ('HUMIDITY'):
              res.data.forEach((el, index) => {
                try {
                  if (!el || !el.device_data) {
                    console.log("Elemento saltato - device_data mancante:", index);
                    return;
                  }
                  if (el.device_data.received_at == null || el.device_data.humidity == null) {
                    console.log("Elemento saltato - dati HUMIDITY mancanti:", index);
                    return;
                  }
                  this.chartOptions_bin.xaxis.categories.push(el.device_data.received_at.substr(0, 10) + "-" + el.device_data.received_at.substr(11, 5));
                  data_.push(el.device_data.humidity);
                } catch (e) {
                  console.log("Errore durante l'elaborazione dell'elemento HUMIDITY:", index, e);
                }
              });
              break;
            case ('TEMPERATURE'):
              res.data.forEach((el, index) => {
                try {
                  if (!el || !el.device_data) {
                    console.log("Elemento saltato - device_data mancante:", index);
                    return;
                  }
                  if (el.device_data.received_at == null || el.device_data.internal_temperature == null) {
                    console.log("Elemento saltato - dati TEMPERATURE mancanti:", index);
                    return;
                  }
                  this.chartOptions_bin.xaxis.categories.push(el.device_data.received_at.substr(0, 10) + "-" + el.device_data.received_at.substr(11, 5));
                  data_.push(el.device_data.internal_temperature);
                } catch (e) {
                  console.log("Errore durante l'elaborazione dell'elemento TEMPERATURE:", index, e);
                }
              });
              break;
            case ('PRESSURE'):
              res.data.forEach((el, index) => {
                try {
                  if (!el || !el.device_data) {
                    console.log("Elemento saltato - device_data mancante:", index);
                    return;
                  }
                  if (el.device_data.received_at == null || el.device_data.pressure == null) {
                    console.log("Elemento saltato - dati PRESSURE mancanti:", index);
                    return;
                  }
                  this.chartOptions_bin.xaxis.categories.push(el.device_data.received_at.substr(0, 10) + "-" + el.device_data.received_at.substr(11, 5));
                  data_.push(el.device_data.pressure);
                } catch (e) {
                  console.log("Errore durante l'elaborazione dell'elemento PRESSURE:", index, e);
                }
              });
              break;
            default:
              break;
          }

          this.series_bin = [{ data: data_, name: req }];
          console.log("Dati elaborati:", data_.length, "elementi");
          this.chartk++;
          this.updateAllChartSubtitles();
          this.overlay = false;
          console.log("END")
        })
        .catch((error) => {
          console.log("Errore durante il caricamento dei dati:", error);
          // Mostra comunque il grafico vuoto in caso di errore
          this.series_bin = [{ data: [], name: req }];
          this.chartk++;
          this.updateAllChartSubtitles();
          this.overlay = false;
        })
    },
    goBack() {
        if (window.history.length > 1) {
            this.$router.go(-1);
        } else {
            this.$router.push('/welcome');
        }
    },
    LoadData() {
      this.scelta = false;
      this.overlay = true;
      this.ChangeDate('1', 'CO2');
    }
  },
  watch: {
    '$store.state.timezone'() {
      this.applyChartsTimezone();
    },
    client(value) {
      // Se stiamo caricando dalla route, non eseguire il watcher
      if (this.isLoadingFromRoute) {
        return;
      }
      
      if (value != undefined &&
        value != null &&
        value != "" &&
        value != 0
      ) {
        this.buildingActive = false;
        this.buildings.length = 0;
        this.buildingValue = '';
        this.buildings = [];
        this.floorActive = true;
        this.floors.length = 0;
        this.floor = '';
        this.floors = [];
        this.floors.length = 0;
        this.areaActive = true;
        this.areas.length = 0;
        this.area = '';
        this.areas = [];
        this.areas.length = 0;
        this.sensorActive = true;
        this.sensor_items.length = 0;
        this.sensorsValue = '';
        this.sensor_items = [];
        this.sensor_items.length = 0;
        this.building_name = '';
        axios.post(this.$store.state.URL_GET_AVAILABLE_BUILDINGS, {
          companyId: value
        })
          .then(res => {
            res.data.forEach(el => {
              var element = { text: el.BuildingName, value: el.id }
              this.buildings.push(element);

            });
          })
      }
      else {
        this.buildingActive = false;
        this.buildings.length = 0;
        this.buildingValue = '';
        this.buildings = [];
        this.building_name = '';
        this.floorActive = true;
        this.floors.length = 0;
        this.floor = '';
        this.floors = [];
        this.floors.length = 0;
        this.areaActive = true;
        this.areas.length = 0;
        this.area = '';
        this.areas = [];
        this.areas.length = 0;
        this.sensorActive = true;
        this.sensor_items.length = 0;
        this.sensorsValue = '';
        this.sensor_items = [];
        this.sensor_items.length = 0;
      }

    },
    building(value) {
      // Se stiamo caricando dalla route, non eseguire il watcher
      if (this.isLoadingFromRoute) {
        return;
      }
      
      if (value != undefined &&
        value != null &&
        value != "" &&
        value != 0
      ) {


        this.floorActive = true;
        this.floors.length = 0;
        this.floor = '';
        this.floors = [];
        this.floor_name = '';
        this.floors.length = 0;
        this.areaActive = true;
        this.areas.length = 0;
        this.area = '';
        this.areas = [];
        this.areas.length = 0;
        this.sensorActive = true;
        this.sensor_items.length = 0;
        this.sensorsValue = '';
        this.sensor_items = [];
        this.sensor_items.length = 0;
        const selectedOption = this.buildings.find(option => option.value === value);
        this.building_name = selectedOption.text
        this.floorActive = false;
        axios.post(this.$store.state.URL_GET_AVAILABLE_FLOORS, {
          buildingId: value
        })
          .then(res => {
            res.data.forEach(el => {
              var element = { text: el.FloorName, value: el.id }
              this.floors.push(element);
            });

          })
      }
      else {
        this.floorActive = false;
        this.floors.length = 0;
        this.floor = '';
        this.floors = [];
        this.floor_name = '';
        this.floors.length = 0;
        this.areaActive = true;
        this.areas.length = 0;
        this.area = '';
        this.areas = [];
        this.areas.length = 0;
        this.sensorActive = true;
        this.sensor_items.length = 0;
        this.sensorsValue = '';
        this.sensor_items = [];
        this.sensor_items.length = 0;
      }
    },
    floor(value) {
      // Se stiamo caricando dalla route, non eseguire il watcher
      if (this.isLoadingFromRoute) {
        return;
      }
      
      if (value != undefined &&
        value != null &&
        value != "" &&
        value != 0
      ) {

        this.areaActive = true;
        this.areas.length = 0;
        this.area = '';
        this.areas = [];
        this.areas.length = 0;
        this.sensorActive = true;
        this.sensor_items.length = 0;
        this.sensorsValue = '';
        this.sensor_items = [];
        this.sensor_items.length = 0;
        this.areaActive = false;
        const selectedOption = this.floors.find(option => option.value === value);
        this.floor_name = selectedOption.text
        axios.post(this.$store.state.URL_GET_AVAILABLE_AREAS, {
          floorId: value
        })
          .then(res => {
            res.data.forEach(el => {
              var element = { text: el.AreaName, value: el.id }
              this.areas.push(element);
            });

          })
      }
      else {

        this.areaActive = false;
        this.areas.length = 0;
        this.area = '';
        this.areas = [];
        this.areas.length = 0;
        this.sensorActive = true;
        this.sensor_items.length = 0;
        this.sensorsValue = '';
        this.sensor_items = [];
        this.sensor_items.length = 0;
      }

    },
    area(value) {
      // Se stiamo caricando dalla route, non eseguire il watcher
      if (this.isLoadingFromRoute) {
        return;
      }
      
      if (value != undefined &&
        value != null &&
        value != "" &&
        value != 0
      ) {
        this.sensor_items.length = 0;
        this.sensor_items = [];
        this.sensorsValue = "";
        this.sensorActive = false;
        // var el = { text: "...", value: "" };
        // this.filterSensors.push(el);
        axios.post(this.$store.state.URL_GET_SENSORS_COMPANY_BUILDING_FLOOR_AREA, {
          companyId: this.client,
          buildingId: this.building,
          floorId: this.floor,
          areaId: value,
          type: "Air"
        })
          .then(res => {
            res.data.forEach(el => {
              var element = { text: el.DisplayName, value: el }
              this.sensor_items.push(element);
            });

          })
      }
      else {
        this.sensor_items.length = 0;
        this.sensor_items = [];
        this.sensorsValue = "";
      }
    },
    buildingValue(value) {
      this.visualizza_dati = false;
      this.floor_items.length = 0;
      this.sensor_items.length = 0;
      value.floors.forEach(el => {
        this.floor_items.push({ text: el.FloorName, value: el })
      })
      this.building_name = value.BuildingName;
      this.floorActive = false;
      this.sensorActive = true;
      this.sensor_name = "";
      this.sensor_img = "";
      this.floor_name = "";
      this.f++;
      this.s++;
    },
    floorValue(value) {
      this.visualizza_dati = false;
      this.sensor_items.length = 0;
      value.sensors.forEach(el => {
        if (el.DispenserType == "Dispenser")
          this.sensor_items.push({ text: el.DisplayName, value: el })
      })

      this.floor_name = value.FloorName;
      this.sensor_name = "";
      this.sensor_img = "";
      this.sensorActive = false;
      this.sensorsValue = '';
      this.s++;
    },
    sensorsValue(value) {
      if (!value) return;
      
      // Reset del grafico quando cambia il sensore
      this.series_bin = [];
      this.chartOptions_bin.xaxis.categories = [];
      this.chart_title = '';
      this.chartk++;
      
      // Mostra sempre lo scheletro del grafico
      this.visualizza_dati = true;
      
      this.sensor_name = value.DisplayName;
      this.sensor_img = value.DispenserImage;
      this.sensor_unique = value.DispenserUnique;
      this.sensor_id = value.DispenserId;
      this.minValue = value.Min_Value;
      this.maxValue = value.Max_Value;
      this.okActive = false;
      
      // Imposta i colori dei filtri temporali (1 day selezionato di default)
      this.colore4h = "#DAE0EC"
      this.colore1d = "#213A8F"
      this.colore3d = "#DAE0EC"
      this.colore1w = "#DAE0EC"
      this.colore2w = "#DAE0EC"
      
      // Imposta i colori delle metriche (CO2 selezionato di default)
      this.coloreCO2 = "#213A8F"
      this.coloreHumidity = "#DAE0EC"
      this.coloreTemperature = "#DAE0EC"
      this.colorePressure = "#DAE0EC"
      
      this.date = [];
      
      // Carica i dati solo se non stiamo già caricando dalla route
      if (!this.isLoadingFromRoute) {
        this.ChangeDate('1', 'CO2');
      }
    }
  },

}

</script>
